//*Detalle del articulo y/o producto que que se desea adquirir *//
//===================================
// PDP / Detalle del articulos / productos

import useFunctionInfo from "@/Hooks/useDataInformation/useFunctionInfo";
import { mappersPDP } from "@/Mappers/products.mapper";
import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import type { products } from "@/Models/MProduct/Products";
import { useEffect, useState } from "react";
import { getIpCliente } from "../Index";

export const useViewInfoProduct = (
  sku: string,
  category: string,
  subCategory: string
) => {
  //Data Product
  const [mDatos, setMDatos] = useState<ProductByIdPdp[]>([]);
  //Loadding por Skeleton
  const [isLoading, setIsLoading] = useState<boolean>(true);
  //hacemos la consulta hacia le back
  const { data: productosInfo, loading: isLoadings } = useFunctionInfo<
    products[]
  >(`/VerCategorias?sku=${sku}`);

  useEffect(() => {
    setIsLoading(true);
    // solo ejecutamos el setTimeout si ya se cargaron los datos.
    if (!isLoadings && productosInfo) {
      const timers = setTimeout(async () => {
        const ipClient = await getIpCliente();
        //data mapping for products
        const resultMapper = await mappersPDP(
          productosInfo,
          category,
          subCategory!,
          String(ipClient)
        );
        setMDatos(resultMapper);
        //loading
        setIsLoading(false);
      }, 200);

      return () => clearTimeout(timers);
    }
  }, [productosInfo, isLoadings, sku]);

  return {
    mDatos,
    isLoading,
  };
};

export const useAddToCardBuy = () => {
  //data: response
  const { postData } = useFunctionInfo<any>("");
  const buyCardSku = "/Carrito";

  return {
    postData,
    buyCardSku,
  };
};

export const useProductSku = (sku: string) => {
  //Data Product
  const [productsData, setProductsData] = useState<products | null>(null);
  //hacemos la consulta hacia le back
  const { data: productosInfo, loading: isLoadings } =
    useFunctionInfo<products>(`/VerCategorias?sku=${sku}`);

  useEffect(() => {
    // solo ejecutamos el setTimeout si ya se cargaron los datos.
    if (!isLoadings && productosInfo) {
      const timers = setTimeout(async () => {
        setProductsData(productosInfo);
      }, 2000);

      return () => clearTimeout(timers);
    }
  }, [productosInfo, isLoadings]);

  return {
    productsData,
    isLoadings,
  };
};
